import React, { useState } from "react";
import "./Sales.css";

const Sales = () => {
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    companyName: "",
    website: "",
    industry: "",
    partnershipType: [],
    integrationDetails: "",
    entityType: "",
    companyCount: "",
    activeUsers: "",
    referralSource: "",
    partnershipTiming: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        partnershipType: checked
          ? [...prevData.partnershipType, value]
          : prevData.partnershipType.filter((item) => item !== value),
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <div className="sales-container">
      <form onSubmit={handleSubmit} className="sales-form">
        <label>Email *</label>
        <input type="email" name="email" required onChange={handleChange} />

        <div className="name-fields">
          <div>
            <label>First Name *</label>
            <input type="text" name="firstName" required onChange={handleChange} />
          </div>
          <div>
            <label>Last Name *</label>
            <input type="text" name="lastName" required onChange={handleChange} />
          </div>
        </div>

        <label>Phone *</label>
        <input type="tel" name="phone" required onChange={handleChange} />

        <label>Company Name *</label>
        <input type="text" name="companyName" required onChange={handleChange} />

        <label>Website URL *</label>
        <input type="url" name="website" required onChange={handleChange} />

        <label>Industry *</label>
        <select name="industry" required onChange={handleChange}>
          <option value="">Select Industry</option>
          {[
            "Accounting", "Aviation", "IT", "Biotechnology", "Marketing", "Real Estate", "Retail", "Telecommunications", "Transportation", "Utilities"
            // Add all 146 industries here
          ].map((industry, index) => (
            <option key={index} value={industry}>{industry}</option>
          ))}
        </select>

        <label>Partnership Type *</label>
        <div className="checkbox-group">
          <label><input type="checkbox" name="partnershipType" value="Affiliate" onChange={handleChange} /> Affiliate</label>
          <label><input type="checkbox" name="partnershipType" value="White-Label" onChange={handleChange} /> White-Label</label>
          <label><input type="checkbox" name="partnershipType" value="Marketplace" onChange={handleChange} /> Marketplace</label>
        </div>

        <label>Entity Type of Main Interest *</label>
        <select name="entityType" required onChange={handleChange}>
          <option value="">Select</option>
          <option value="LLC">LLC</option>
          <option value="C Corporation">C Corporation</option>
        </select>

        <label>How many companies do you need to form/refer per month? *</label>
        <select name="companyCount" required onChange={handleChange}>
          <option value="">Select</option>
          <option value="1-10">1-10</option>
          <option value="11-20">11-20</option>
          <option value="21-50">21-50</option>
          <option value="51-100">51-100</option>
          <option value="100+">100+</option>
        </select>

        <label>How many active users do you have on your platform? *</label>
        <select name="activeUsers" required onChange={handleChange}>
          <option value="">Select</option>
          <option value="0-10">0-10</option>
          <option value="11-100">11-100</option>
          <option value="101-1000">101-1000</option>
          <option value="1001-10000">1001-10000</option>
          <option value="10000+">10000+</option>
        </select>

        <label>How did you first hear about us? *</label>
        <select name="referralSource" required onChange={handleChange}>
          <option value="">Please Select</option>
          <option value="Google">Google</option>
          <option value="Referral">Referral</option>
          <option value="Social Media">Social Media</option>
        </select>

        <label>How soon are you looking to partner with us? *</label>
        <select name="partnershipTiming" required onChange={handleChange}>
          <option value="">Select</option>
          <option value="Immediately">Immediately</option>
          <option value="This week">This week</option>
          <option value="This month">This month</option>
          <option value="Not sure">Not sure</option>
        </select>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Sales;
